module.exports = __webpack_public_path__ + "assets/1e859b174e3f263c07b67e4749424dd7.mp3";